import { render, staticRenderFns } from "./Tf1.vue?vue&type=template&id=4ae018d4&"
import script from "./Tf1.vue?vue&type=script&lang=js&"
export * from "./Tf1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports